module.exports = __webpack_public_path__ + "fonts/Lato-Italic.ba676cba.woff2";